var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHolidayCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 0V1.25H0.25V28.75H27.75V1.25H22.75V0H20.25V1.25H7.75V0H5.25ZM2.75 3.75H5.25V5H7.75V3.75H20.25V5H22.75V3.75H25.25V6.25H2.75V3.75ZM2.75 8.75H25.25V26.25H2.75V8.75ZM10.25 11.25V13.75H12.75V11.25H10.25ZM15.25 11.25V13.75H17.75V11.25H15.25ZM20.25 11.25V13.75H22.75V11.25H20.25ZM5.25 16.25V18.75H7.75V16.25H5.25ZM10.25 16.25V18.75H12.75V16.25H10.25ZM15.25 16.25V18.75H17.75V16.25H15.25ZM20.25 16.25V18.75H22.75V16.25H20.25ZM5.25 21.25V23.75H22.75V21.25H5.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidayCalendar);
export default __webpack_public_path__ + "static/media/holiday-calendar.d66643357778e940f4b7d889afd5f589.svg";
export { ForwardRef as ReactComponent };